import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import siteVars from '~/Classes/siteVars'
import Icons from '~/Common-Objects/UI/Icons/index'
import Select from '~/Common-Objects/UI/Forms/Select/Select'
import TextInput from '~/Common-Objects/UI/Forms/TextInput/TextInput'
import { SocialImageSelector } from './shared'
import FileManager from '../../../includes/fileManager/fileManager'
import { alterSiteDrawer } from '../../../../../data/actions/siteActions'

export default function VideoThumbSelect({ video, available, setVideo = () => {} }) {
    const dispatch = useDispatch()
    const [timestamp, setTimestamp] = useState(
        video.thumbTimestamp ? secondsToTimestamp(video.thumbTimestamp) : '00:00'
    )
    const [customThumb, setCustomThumb] = useState(video.thumbType === 'custom' ? video.thumb : null)

    const changeTimestamp = (e) => {
        const val = e.target.value
        setTimestamp(val)
        if (!validateTimestamp(val)) {
            saveTimestamp(val)
        }
    }

    const saveTimestamp = (val) => {
        setVideo({ ...video, thumbTimestamp: timestampToSeconds(val) })
    }

    const setImage = (thumb) => {
        setVideo({ ...video, thumb })
    }

    const removeImage = () => {
        setCustomThumb(null)
        setImage(null)
    }

    const openImageSelector = () => {
        const drawerContent = (
            <FileManager
                fileTypes={'images'}
                system={false}
                onFileClick={(e) => {
                    const url = e.url.replace(siteVars.repoEndPoint, '')
                    setCustomThumb(url)
                    setImage(url)
                    dispatch(alterSiteDrawer(false, true, 'right', null))
                }}
            />
        )
        dispatch(alterSiteDrawer(true, true, 'right', drawerContent, true, '100vw', 'fix-height'))
    }

    const validTimestamp = validateTimestamp(timestamp, video.meta?.duration)
    const checkStyle = {
        zIndex: 999,
        position: 'absolute',
        top: -10,
        right: -10,
        borderRadius: '50%',
        backgroundColor: 'var(--cyan-500)',
        padding: 5,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    }

    return (
        <div>
            <div className='row'>
                <div className='col-xs-12 col-sm-12 col-md-7 col-lg-6'>
                    <Select
                        outerClassName='mar-b20'
                        label={
                            <div>
                                Thumbnail
                                <div className='text-grey text-xsml'>Only available on Facebook and LinkedIn</div>
                            </div>
                        }
                        data={[
                            { label: 'Platform Default', value: null },
                            { label: 'Choose from Generated Thumbnail', value: 'select' },
                            { label: 'Video Timestamp', value: 'timestamp' },
                            { label: 'Custom', value: 'custom' }
                        ]}
                        value={available ? video.thumbType : null}
                        disabled={!available}
                        onChange={(e) => setVideo({ ...video, thumbType: e.target.value })}
                    />
                </div>
            </div>
            {available && (
                <>
                    {video.thumbType === 'select' && (
                        <div className='mar-b30'>
                            <label className='txtInput_label'>Choose Thumbnail</label>
                            <div className='row'>
                                {video.thumbs.slice(0, 5).map((thumb, i) => {
                                    let classes = 'col-xs social-video-thumb'
                                    if (thumb === video.thumb) {
                                        classes += ' selected'
                                    }
                                    return (
                                        <div className={classes} key={i}>
                                            <div style={{ width: 'fit-content', position: 'relative' }}>
                                                <img
                                                    src={`${siteVars.repoEndPoint + thumb}?date=${video.updatedAt}`}
                                                    onClick={() => setImage(thumb)}
                                                />
                                                {thumb === video.thumb && (
                                                    <Icons
                                                        style={{ height: 20, width: 20 }}
                                                        icon='tick'
                                                        color='white'
                                                        outerStyle={checkStyle}
                                                    />
                                                )}
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>
                            <div className='row'>
                                {video.thumbs.slice(5, 10).map((thumb, i) => {
                                    let classes = 'col-xs social-video-thumb'
                                    if (thumb === video.thumb) {
                                        classes += ' selected'
                                    }
                                    return (
                                        <div className={classes} key={i + 5}>
                                            <div style={{ width: 'fit-content', position: 'relative' }}>
                                                <img
                                                    src={`${siteVars.repoEndPoint + thumb}?date=${video.updatedAt}`}
                                                    onClick={() => setImage(thumb)}
                                                />
                                                {thumb === video.thumb && (
                                                    <Icons
                                                        style={{ height: 20, width: 20 }}
                                                        icon='tick'
                                                        color='white'
                                                        outerStyle={checkStyle}
                                                    />
                                                )}
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                    )}

                    {video.thumbType === 'timestamp' && (
                        <div className='row mar-b40'>
                            <div className='col-xs-12 col-sm-8 col-md-6 col-lg-4'>
                                <TextInput
                                    error={validTimestamp}
                                    label='Timestamp'
                                    value={timestamp}
                                    type='text'
                                    placeholder='mm:ss'
                                    onChange={changeTimestamp}
                                />
                            </div>
                        </div>
                    )}

                    {video.thumbType === 'custom' && (
                        <div className='mar-b30'>
                            <SocialImageSelector
                                image={customThumb ? siteVars.repoEndPoint + customThumb : null}
                                onAdd={openImageSelector}
                                onRemove={removeImage}
                            />
                        </div>
                    )}
                </>
            )}
        </div>
    )
}

function timestampToSeconds(timestamp) {
    const parts = timestamp.split(':')
    return parseInt(parts[0]) * 60 + parseInt(parts[1])
}

function secondsToTimestamp(seconds) {
    if (!seconds) return '00:00'
    let minutes = Math.floor(seconds / 60)
    let secs = seconds % 60
    // ensure its 2 digits
    if (secs < 10) {
        secs = `0${secs}`
    }
    if (minutes < 10) {
        minutes = `0${minutes}`
    }
    return `${minutes}:${secs}`
}

function validateTimestamp(value, duration) {
    if (!value || !duration) return ''
    const parts = value.split(':')
    if (parts.length !== 2) return 'Invalid Format'
    if (isNaN(parts[0]) || isNaN(parts[1])) return 'Invalid Format'
    const total = timestampToSeconds(value)
    if (total > duration) return 'Timestamp is greater than video duration'
    return ''
}
